import axios, { AxiosResponse } from "axios";

const API_HOST = process.env.REACT_APP_BACKEND_API_URL;

const CLIENT_ID = process.env.REACT_APP_API_CLIENT_ID;
const CLIENT_SECRET = process.env.REACT_APP_API_CLIENT_SECRET;


class LoginFunctionClass {
  async generateAccessToken(): Promise<any> {
    const apiUrl = `${API_HOST}global/create-access-token`;

    const result = await axios({
      method: "get",
      url: apiUrl,
      headers: {
        Authorization: `Basic ${CLIENT_ID}:${CLIENT_SECRET}`,
      },
    })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          return {
            status: true,
            data: response.data.data,
            statusCode: response.status,
          };
        } else {
          return {
            status: false,
            data: "Invalid Client Credentials",
            statusCode: response.status,
          };
        }
      })
      .catch((err: any) => {
        let statusCode = 500;
        let statusMsg = "CONNECTION REFUSED";
        if (err.response) {
          statusMsg = err.response.data.error;
          statusCode = err.response.status;
        }
        return { status: false, message: statusMsg, statusCode: statusCode };
      });
    return result;
  }

  async login(
    accessToken: string,
    username: string,
    password: string
  ): Promise<any> {
    const apiUrl = `${API_HOST}global/admin-login`;

    const result = await axios
      .post(
        apiUrl,
        {
          username: username,
          password: password,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      )
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          return {
            status: true,
            data: response.data,
            statusCode: response.status,
          };
        } else {
          return {
            status: false,
            data: response.data,
            statusCode: response.status,
          };
        }
      })
      .catch((err: any) => {
        let statusCode = 500;
        let statusMsg = "CONNECTION REFUSED";
        if (err.response) {
          statusMsg = err.response.data.error;
          statusCode = err.response.status;
        }
        return { status: false, message: statusMsg, statusCode: statusCode };
      });
    return result;
  }

  async logout(accessToken: string, sessionToken: string): Promise<any> {
    const apiUrl = `${API_HOST}global/logout`;

    return await axios
      .post(
        apiUrl,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}:${sessionToken}`,
          },
        }
      )
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          return {
            status: true,
            data: response.data,
            statusCode: response.status,
          };
        } else {
          return {
            status: false,
            data: response.data,
            statusCode: response.status,
          };
        }
      })
      .catch((err: any) => {
        let statusCode = 500;
        let statusMsg = "CONNECTION REFUSED";
        if (err.response) {
          statusMsg = err.response.data.error;
          statusCode = err.response.status;
        }
        return { status: false, message: statusMsg, statusCode: statusCode };
      });
  }

  async checkSession(sessionToken: string | null, accessToken: string | null) {
    if (accessToken && sessionToken) {
      const options = {
        headers: {
          Authorization: `Bearer ${accessToken}:${sessionToken}`,
        },
      };
      const result = await axios
        .get(API_HOST + "global/check-session", options)
        .then((response) => {
          if (response.status === 200) {
            return {
              status: true,
              data: response.data,
              message: "Session Active",
            };
          } else {
            return { status: false, data: {}, message: "Session Expired" };
          }
        })
        .catch((err) => {
          return { status: false, data: {}, message: err };
        });
      return result;
    }
    return false;
  }
}

const LoginFunction = new LoginFunctionClass();
export default LoginFunction;
